export class AttendancesList {
    total: number;
    page: number;
    data: ListAttendanceItem[];

    constructor () {
        this.page = 1;
        this.data = [];
    }
}

export class ListAttendanceItem {
    id: number;
    ais_id: number;
    family_name: string;
    given_name: string;
    dob: string;
    gender: string;
    nationality: string;
    homeroom: string;
    class_id: number;
    is_present: string;
    attendances: Attendances[];
    note: string;
    school_year_id: number;
    campus_id: number;
    semester_id: number;
    weeks: any[];
    is_current_class: boolean;
    constructor() {
        this.attendances = [];    
    }
}

export class Attendances {
    is_present: any;
    date: any;
    note: any;
}

export class CheckAttendances {
    note: string;
    class_id: number;
    student_id: number;
    present: boolean;
    date: any;
}



// WEBPACK FOOTER //
// ./src/holiday/models/Attendances.ts